export default "__VITE_ASSET__DDaJIioa__"